import { roleColors } from "./roleColors";
import type { UserRoleEnum } from "@globals";
import { ContextualError } from "@lib/utils/ContextualError";

/**
 * Get the badge color for a user role
 * @param role - The role enum value
 * @returns The color string for badges
 */
export function getRoleColor(role: UserRoleEnum): string {
  const roleColor = roleColors.get(role);
  if (roleColor === undefined) {
    throw new ContextualError("No color defined for role", {
      role,
      known_roles: [...roleColors.keys()]
    });
  }
  return roleColor;
}
